<template>
  <v-container fluid>
    <div class="py-4 px-2 d-flex justify-space-between">
      <div class="d-flex align-center">
        <span class="font-weight-medium">ฟีเจอร์ (แยกตามพนักงาน)</span>
      </div>
      <div class="d-flex align-center">
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-inner-icon="mdi-magnify"
          clearable
          flat
          solo
          dense
          hide-details
        ></v-text-field>
        <v-autocomplete
          v-model="filterOrganization"
          class="ml-4"
          :items="organizations"
          item-text="title_th"
          item-value="title_th"
          label="หน่วยงาน"
          clearable
          flat
          solo
          dense
          hide-details
        ></v-autocomplete>
      </div>
    </div>

    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="filterEmployees"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>

    <EmployeeFeatureForm
      :employeeFeature="employeeFeature"
      :employeeFeatureInit="employeeFeatureInit"
      :formShow="formShow"
      @isEmployeeFeatureDataChange="
        (value) => (isEmployeeFeatureDataChange = value)
      "
      @formActionCompleted="handleFormActionCompleted"
      @onReset="handleFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="confirmDialogDataChange = false"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeFeatureForm from '@/views/feature/EmployeeFeatureForm.vue'

export default {
  name: 'EmployeeFeature',

  components: {
    EmployeeFeatureForm,
    ConfirmDialog,
  },

  data() {
    return {
      sortBy: ['name'],
      sortDesc: [false],
      loading: true,
      search: '',
      filterOrganization: null,
      employeeFeature: {},
      employeeFeatureInit: {},
      formShow: false,
      isEmployeeFeatureDataChange: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'ชื่อพนักงาน',
          align: 'start',
          value: 'name',
        },
        {
          text: 'ฟีเจอร์ที่ใช้งาน',
          align: 'center',
          value: 'feature_count',
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization',
          filter: (value) => {
            if (!this.filterOrganization) {
              return true
            }
            return value === this.filterOrganization
          },
        },
      ]
    },
    filterEmployees() {
      return this.employees.map((employee) => ({
        employee_uuid: employee.employee_uuid,
        name: `${employee.firstname_th} ${employee.lastname_th}`,
        feature_count: this.employeeFeatures.filter(
          (element) => element.employee.employee_uuid === employee.employee_uuid
        ).length,
        employee_code: employee.employee_code,
        organization: employee.organization.title_th,
        features: this.employeeFeatures.filter(
          (element) => element.employee.employee_uuid === employee.employee_uuid
        ),
      }))
    },
    employees() {
      return this.$store.state.employee.employees
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    companyFeatures() {
      return this.$store.state.feature.companyFeatures
    },
    employeeFeatures() {
      return this.$store.state.feature.employeeFeatures
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ฟีเจอร์ (แยกตามพนักงาน)',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetchEmployees',
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchCompanyFeatures: 'feature/fetchCompanyFeatures',
      fetchEmployeeFeatures: 'feature/fetchEmployeeFeatures',
    }),
    classRowSelected(row) {
      if (this.employeeFeature.employee_uuid === row.employee_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.employeeFeature.employee_uuid === row.employee_uuid) {
        this.employeeFeature = {}
        this.employeeFeatureInit = {}
        this.formShow = false
      } else {
        this.employeeFeature = {
          employee_uuid: row.employee_uuid,
          name: row.name,
          employee_code: row.employee_code,
          organization: row.organization,
          features: this.companyFeatures.map((company) => ({
            ...company,
            isFeature: !!row.features.find(
              (el) => el.feature.feature_uuid === company.feature.feature_uuid
            ),
            employee_count: this.employeeFeatures.filter(
              (employee) =>
                employee.feature.feature_uuid === company.feature.feature_uuid
            ).length,
          })),
        }
        this.employeeFeatureInit = {
          features: this.employeeFeature.features.map((el) => ({ ...el })),
        }
        this.formShow = true
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeeFeatureDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleFormActionCompleted() {
      this.formShow = false
      this.employeeFeature = {}
      this.employeeFeatureInit = {}
      this.loadData()
    },
    handleFormReset(formAction) {
      this.formShow = false
      this.employeeFeature = {}
      this.employeeFeatureInit = {}
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      Promise.all([
        this.fetchEmployees({
          company_uuid,
          params: {
            is_active: true,
          },
        }),
        this.fetchOrganizations({
          company_uuid,
          params: { dpc: 'employee-to-list-organization' },
        }),
        this.fetchCompanyFeatures({
          company_uuid,
          is_active: true,
        }),
        this.fetchEmployeeFeatures(company_uuid),
      ])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEmployeeFeatureDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
}
</script>
